import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import brooklyn__asset from "@/assets/restore/locations/brooklyn-heights.jpg.asset.json";
import manhasset__asset from "@/assets/restore/locations/manhasset.jpg.asset.json";
import manhattan__asset from "@/assets/restore/locations/manhattan.jpg.asset.json";
import melville__asset from "@/assets/restore/locations/melville.jpg.asset.json";
import nassau__asset from "@/assets/restore/locations/nassau.jpg.asset.json";
import queens__asset from "@/assets/restore/locations/queens.jpg.asset.json";
import whitePlains__asset from "@/assets/restore/locations/white-plains.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Brooklyn Heights",
    address: "300 Cadman Plaza W, Brooklyn",
    img: brooklyn__asset.url,
    mapUrl: map("300 Cadman Plaza W Brooklyn NY"),
    to: "/locations/new-york/brooklyn-heights/",
  },
  {
    name: "Manhasset",
    address: "1129 Northern Blvd",
    img: manhasset__asset.url,
    mapUrl: map("1129 Northern Blvd Manhasset NY"),
    to: "/locations/restore-northeast/",
  },
  {
    name: "Manhattan",
    address: "240 W 37th St, 5th Floor",
    img: manhattan__asset.url,
    mapUrl: map("240 W 37th St 5th Floor New York NY"),
    to: "/locations/restore-northeast/",
  },
  {
    name: "Melville",
    address: "555 Broadhollow Rd",
    img: melville__asset.url,
    mapUrl: map("555 Broadhollow Rd Melville NY"),
    to: "/locations/restore-northeast/",
  },
  {
    name: "Nassau County",
    address: "1979 Marcus Ave, Suite 210, Lake Success",
    img: nassau__asset.url,
    mapUrl: map("1979 Marcus Ave Suite 210 Lake Success NY"),
    to: "/locations/new-york/nassau-county/",
  },
  {
    name: "Queens",
    address: "118-35 Queens Blvd, Forest Hills Tower",
    img: queens__asset.url,
    mapUrl: map("118-35 Queens Blvd Forest Hills NY"),
    to: "/locations/new-york/queens/",
  },
  {
    name: "White Plains",
    address: "50 Main Street",
    img: whitePlains__asset.url,
    mapUrl: map("50 Main Street White Plains NY"),
    to: "/locations/new-york/white-plains/",
  },
];

export const Route = createFileRoute("/locations/new-york/")({
  head: () => ({
    meta: [
      { title: "New York Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in New York. Book a free personal hair loss consultation at our Brooklyn Heights, Nassau County, Queens, and White Plains locations.",
      },
      { property: "og:title", content: "New York Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair locations across New York and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/new-york/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/new-york/" }],
  }),
  component: () => <StateLocationsHub stateName="New York" cities={cities} />,
});